<template>
  <div class="ODP__group">
    <div class="promocode --success" v-if="promoCodeInformation.promo_code_exist && promoCodeInformation.promo_code_valid">
      <span class="promocode__label">{{ $t('valid_promo_code_message') }}</span>
    </div>

    <div class="promocode --warning" v-if="promoCodeInformation.promo_code_exist && !promoCodeInformation.promo_code_valid">
      <span class="promocode__label">{{ $t('promo_code_does_not_apply_discounts') }}</span>
    </div>

    <div class="promocode" v-else-if="promoCodeInformation.promo_code && !promoCodeInformation.promo_code_exist">
      <span class="promocode__label">{{ $t('promo_code_does_not_exist') }}</span>
    </div>
  </div>
</template>

<script>
export default {
  name: 'promoCode',
  props: {
    promoCodeInformation: {
      required: true,
      type: Object,
      default: () => {
        return {}
      }
    }
  }
}
</script>

<style lang="sass" scoped>
.promocode
  display: flex
  align-items: center
  font-size: var(--font-size-sm)
  justify-content: center
  background-color: var(--color-overlay-05)
  color: var(--color-onSurface)
  padding: 0 .75rem
  border-radius: .25rem
  border: 1px solid var(--color-overlay-20)
  font-weight: 600
  text-transform: uppercase
  &.--success
    color: var(--color-onSuccess)
    background-color: var(--color-success)
  &.--warning
    color: var(--color-onWarning)
    background-color: var(--color-warning)
</style>
